import { getVendorPrefix } from './Helper';

(function() {
    var lastTime = 0;
    var vendors = ['webkit', 'moz'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame =
            window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
                timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

if (typeof HTMLElement !== 'function'){
    var _HTMLElement = function(){};
    _HTMLElement.prototype = HTMLElement.prototype;
    HTMLElement = _HTMLElement;
}

function getSliderPreviews(acc, item, key) {
    return `${acc}<li class="slider__preview">
    <a href="#" class="slider__control slider__preview-link"${key === 0 ? ' data-active' : ''} data-slide="${key}">${key}. Bild</a>
  </li>`;
}

function getSliderControlsInner(slides) {
    return `
  <a data-direction="previous" href="#" class="slider__control slider__arrow-control slider__previous">Vorheriges Bild</a>
  <ul class="slider__previews">
    ${slides.reduce(getSliderPreviews, '')}
  </ul>
  <a data-direction="next" href="#" class="slider__control slider__arrow-control slider__next">Nächstes Bild</a>
  `;
}

function createSlide() {
    const slide = document.createElement('div');
    slide.classList.add('slide');
    return slide;
}

function getSliderControls(slides) {
    const controls = document.createElement('nav');
    controls.classList.add('slider__controls');
    controls.innerHTML = getSliderControlsInner(slides);
    return controls;
}

const transformPrefix = getVendorPrefix(["transform", "msTransform", "MozTransform", "WebkitTransform", "OTransform"]);

export default class Slider extends HTMLElement {
    createdCallback() {
        // Default Values
        this.currentIndex = 0;
        this.mouseDelta = 0;
        this.touching = false;

        // DOM Elements Values
        this.slides = Array.from(this.querySelectorAll('.slide'));
        this.inner = this.querySelector('.slider__inner');
        this.visibleSlides = [createSlide(), createSlide(), createSlide(), createSlide(), createSlide()];

        // Bind Events to class
        this._navClicked = this._navClicked.bind(this);
        this._clicked = this._clicked.bind(this);
        this._moved = this._moved.bind(this);
        this._released = this._released.bind(this);
        this._update = this._update.bind(this);
        this._resized = this._resized.bind(this);
        this._touched = this._touched.bind(this);
        this._touchMoved = this._touchMoved.bind(this);
        this._touchReleased = this._touchReleased.bind(this);

        // Create Visible Slides
        this._generateMarkup();
        this._initView();

        // Start Listening for updates
        requestAnimationFrame(this._update);
    }

    _generateMarkup() {
        // Generate Slider Controls
        this.appendChild(getSliderControls(this.slides));

        // Remove Slides from View, cause we will only have enough view "slots" to always show the previous, current and next slide
        this.slides.map(slide => slide.parentNode.removeChild(slide));
        this.visibleSlides.map(slide => this.inner.appendChild(slide));
    }

    _initView() {

        // Update View to show current Slide in View
        this.rendering = true;
        window.requestAnimationFrame(() => {
            this._updateView(this.defaultIndexArray);
            this.translateX = this.translateCenter;

            window.requestAnimationFrame(() => {
                this.rendering = false;
            });
        });
    }

    _resized() {
        this._initView();
    }

    attachedCallback() {
        this.addEventListener('click', this._navClicked);
        this.addEventListener('mousedown', this._clicked);
        this.addEventListener('mousemove', this._moved);
        this.addEventListener('mouseup', this._released);
        this.addEventListener('touchstart', this._touched);
        this.addEventListener('touchmove', this._touchMoved);
        this.addEventListener('touchend', this._touchReleased);

        // In case Mouse leaves window, while dragging
        document.addEventListener('mouseout', this._released);

        window.addEventListener('resize', this._resized);
    }

    detachedCallback() {
        this.removeEventListener('click', this._navClicked);
        this.removeEventListener('mousedown', this._clicked);
        this.removeEventListener('mousemove', this._moved);
        this.removeEventListener('mouseup', this._released);
        this.removeEventListener('touchstart', this._touched);
        this.removeEventListener('touchmove', this._touchMoved);
        this.removeEventListener('touchend', this._touchReleased);

        // In case Mouse leaves window, while dragging
        document.removeEventListener('mouseout', this._released);

        window.removeEventListener('resize', this._resized);
    }

    _createSlide() {
        const slide = document.createElement('div');
        slide.classList.add('slide');
        return slide;
    }

    getPageXFor(ev) {
        if (typeof ev.pageX === 'undefined') {
            return ev.touches[0].pageX;
        } else {
            return ev.pageX;
        }
    }

    _clicked(ev) {
        let { target } = ev;

        // Check if Click Target is part of slider
        while(target) {

            // Slider Navigation has it's own event Listener
            if (this._targetIsSliderControl(target)) {
                return false;
            }

            if (target === this) {
                ev.preventDefault();

                // Save starting pageX
                this.startPageX = this.getPageXFor(ev);

                // Set Dom Indicator
                this.dragging = true;
                return true;
            }
            target = target.parentNode;
        }

        return false;
    }

    _moved(ev) {
        if (this.dragging) {
            this.mouseDelta = this.startPageX - this.getPageXFor(ev);
            return true;
        }

        return false;
    }

    _released() {
        if (this.dragging) {

            // Check if slider was dragged far enough to switch slide
            if (Math.abs(this.mouseDelta) >= this.dragThreshold) {
                this._deactivatePreviewLink(this._getPreviewLink(this.currentIndex));

                // Next or previous Slide
                if (this.mouseDelta > 0) {
                    this._updateSliderAfterRelease(this.nextIndex, -this.width);
                } else {
                    this._updateSliderAfterRelease(this.previousIndex, this.width);
                }
            } else {

                // Always reset Dragging
                this._resetAfterDrag();
            }

            return true;
        }

        return false;
    }

    _updateSliderAfterRelease(newCurrentIndex, offsetView) {
        this.currentIndex = newCurrentIndex;
        window.requestAnimationFrame(() => {
            this._updateView(this.defaultIndexArray);
            this.mouseDelta += offsetView;
            this.translateX = this.translateCenter + this.mouseDelta;
            this._resetAfterDrag();
        });

        this._activatePreviewLink(this._getPreviewLink(this.currentIndex));
    }

    _resetAfterDrag() {
        window.requestAnimationFrame(() => {
            this.dragging = false;
            this.mouseDelta = 0;
            this.translateX = this.translateCenter;
        });
    }

    _touched(ev) {
        if (this._clicked(ev)) {
            this.touching = true;
            // this.pageY = ev.pageY;
        }
    }

    _touchReleased(ev) {
        this._released(ev);
        this.touching = false;
    }

    _touchMoved(ev) {
        if (this._moved(ev)) {
            /*
            this.newPageY = ev.pageY;
            console.log(this.pageY, ev.pageY);
            this.mouseYDelta = this.pageY - this.newPageY;
            console.log(this.mouseYDelta);
            */
            /// console.log(this.pageY, ev.pageY, this.mouseYDelta);
            // this.pageY = ev.pageY;
        }
    }

    _update() {

        if (this.dragging) {
            this.translateX = this.translateCenter + this.mouseDelta;
        }

        if (this.touching) {
            this.pageY = this.newPageY;
            // window.scrollBy(0, this.mouseYDelta);
            // Reset pageY to calculate new mouseYDelta after update with new value
        }

        requestAnimationFrame(this._update);
    }

    _navClicked(ev) {
        const { target } = ev;

        if (this._targetIsSliderControl(target)) {
            ev.preventDefault();
            ev.stopPropagation();

            // Prevent Double Click
            if (this.rendering) {
                return false;
            }

            const slide = this._getSlideFromSliderControl(target);

            if (this.currentIndex !== slide) {
                this._deactivatePreviewLink(this._getPreviewLink(this.currentIndex));
                this._activatePreviewLink(this._getPreviewLink(slide));

                // Calculated Value
                this.rendering = true;
                if (this.currentIndex > slide) {

                    // Show previous Slide
                    const movingIndices = [
                        this.getPreviousIndexBy(3),
                        this.getPreviousIndexBy(2),
                        this.previousIndex,
                        this.currentIndex,
                        this.nextIndex,
                    ];
                    this._prepareToMove(slide, this.width * 3, movingIndices);
                } else {

                    // Show next Slide
                    const movingIndices = [
                        this.previousIndex,
                        this.currentIndex,
                        this.nextIndex,
                        this.getNextIndexBy(2),
                        this.getNextIndexBy(3),
                    ];
                    this._prepareToMove(slide, this.width, movingIndices)
                }
            }
        }
    }

    _targetIsSliderControl(target) {
        return target.classList.contains('slider__control');
    }

    _getSlideFromSliderControl(target) {

        // Slide Previews
        if (typeof target.dataset.slide !== 'undefined') {
            return parseInt(target.dataset.slide, 10);
        }

        // Arrow Nav Buttons
        if (typeof target.dataset.direction !== 'undefined') {
            switch(target.dataset.direction) {
                case 'next':
                    return this.nextIndex;
                case 'previous':
                    return this.previousIndex;
                default:
                    return 0;
            }
        }

        return 0;
    }

    _prepareToMove(newCurrentIndex, translateX, slideOrder) {
        window.requestAnimationFrame(() => {
            this._updateView(slideOrder);
            this.translateX = translateX;

            window.requestAnimationFrame(() => {
                this._cleanupAfterMove(newCurrentIndex);
            });
        });
    }

    /**
     *
     * @param {number} newCurrentIndex
     */
    _cleanupAfterMove(newCurrentIndex) {
        this.rendering = false;
        this.translateX = this.width * 2;
        this.currentIndex = newCurrentIndex;
        this._updateView(this.defaultIndexArray);
    }

    /**
     *
     * Matches the visible Slides with the indexes in the supplied array
     *
     * @param {array} newSlides indexes of slides, that should be in view
     */
    _updateView(newSlides) {
        this.visibleSlides = this.visibleSlides.map((slide, index) => {
            slide.innerHTML = this.slides[newSlides[index]].innerHTML;
            return slide;
        });
    }

    /**
     *
     * @param {number} slide
     */
    _getPreviewLink(slide) {
        return this.querySelector(`.slider__preview-link[data-slide="${slide}"]`);
    }

    _deactivatePreviewLink(previewLink) {
        delete previewLink.dataset.active;
    }

    _activatePreviewLink(previewLink) {
        previewLink.dataset.active = '';
    }

    get maxDragWidth() {
        return this.width * (this.slides.length - 1);
    }

    get width() {
        if (matchMedia("(min-width: 30em)").matches) {
            return this.getBoundingClientRect().width * .56;
        }

        return this.getBoundingClientRect().width * .86;
    }

    get translateOffset() {
        return (this.getBoundingClientRect().width - this.width) / 2;
    }

    getPreviousIndexBy(offset) {
        const returnIndex = this.currentIndex - offset;

        if (returnIndex < 0) {
            return this.slides.length + returnIndex;
        }

        return returnIndex;
    }

    getNextIndexBy(offset) {
        const returnIndex = this.currentIndex + offset;

        if (returnIndex > this.slides.length - 1) {
            return returnIndex - this.slides.length;
        }

        return returnIndex;
    }

    get previousIndex() {
        return this.getPreviousIndexBy(1);
    }

    get nextIndex() {
        return this.getNextIndexBy(1);
    }

    get dragThreshold() {
        if (matchMedia("(max-width: 480px)").matches) {
            return 80;
        }

        if (matchMedia("(max-width: 980px)").matches) {
            return 120;
        }
        return 250;
    }

    get dragging() {
        return this.getAttribute('dragging');
    }

    set dragging(value) {
        if (value) {
            this.setAttribute('dragging', value);
        } else {
            this.removeAttribute('dragging');
        }
    }

    get rendering() {
        return this.getAttribute('rendering');
    }

    set rendering(value) {
        if (value) {
            this.setAttribute('rendering', value);
        } else {
            this.removeAttribute('rendering');
        }
    }

    getMaXMinTranslate(to) {
        return Math.min(this.maxDragWidth, Math.max(0, to))
    }

    get translateCenter() {
        return this.width * 2;
    }

    set translateX(to) {
        const maxMinTo = this.getMaXMinTranslate(to);
        this.inner.style[transformPrefix] = `translateX(-${to - this.translateOffset}px)`;
    }

    get translateX() {
        const match=/translateX\(([-]?[0-9]+)px\)/;
        const result = this.inner.style[transformPrefix].match(match);
        if (result.length > 1) {
            // Return first matching group of regex
            return parseInt(result[1], 10);
        }

        return 0;
    }

    get defaultIndexArray() {
        return [
            this.getPreviousIndexBy(2),
            this.previousIndex,
            this.currentIndex,
            this.nextIndex,
            this.getNextIndexBy(2),
        ];
    }
}



// WEBPACK FOOTER //
// ./wp-content/themes/template/js/src/Modules/Slider.js